/* unplugin-vue-components disabled */import { render } from "./openboxlist.vue?vue&type=template&id=f261f0a2&scoped=true"
import script from "./openboxlist.vue?vue&type=script&lang=js"
export * from "./openboxlist.vue?vue&type=script&lang=js"

import "./openboxlist.vue?vue&type=style&index=0&id=f261f0a2&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f261f0a2"]])

export default __exports__